import { render } from "./dpp-ctacard.presentational.vue?vue&type=template&id=48344d36"
import script from "./dpp-ctacard.presentational.vue?vue&type=script&lang=js"
export * from "./dpp-ctacard.presentational.vue?vue&type=script&lang=js"

import "./dpp-ctacard.presentational.vue?vue&type=style&index=0&id=48344d36&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__